import { createSlice } from '@reduxjs/toolkit';
import { authenticateUser, forgotPassword, getProfile, logoutUser } from './api';
import { initialState } from './api/interface';
import { removeItem, setItem } from '../../utils/localStorage';
import { config } from '../../utils/utils';

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    registrationSuccess: (state, action) => {
      state.user = action.payload.user;
      state.accessToken = action.payload.user.api_token;
      setItem(config.AUTH_KEY, action.payload.user?.api_token);
      setItem(config.INFO, action.payload.user);
    },
    updateUserProfile: (state, action) => {
      state.user = action.payload.user;
      setItem(config.INFO, action.payload.user);
    },
    logoutUserFromLocal: (state) => {
      state.isError = false;
      state.isLoading = false;
      state.user = undefined;
      state.accessToken = '';
      removeItem(config.AUTH_KEY);
      removeItem(config.INFO);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(authenticateUser.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(authenticateUser.fulfilled, (state, action) => {
      state.isLoading = false;
      state.accessToken = action.payload?.data?.data?.api_token;
      state.user = action.payload.data.data;
      setItem(config.AUTH_KEY, action.payload?.data?.data?.api_token);
      setItem(config.INFO, action.payload.data.data);

    });
    builder.addCase(authenticateUser.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
    });

    builder.addCase(getProfile.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getProfile.fulfilled, (state, action) => {
      state.isLoading = false;
      setItem(config.INFO, action.payload.data.data.user);
      state.user = action.payload.data.data.user;

    });
    builder.addCase(getProfile.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
    });
    builder.addCase(logoutUser.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(logoutUser.fulfilled, (state, _) => {

      state.user = undefined;
      state.isLoading = false;
      removeItem(config.AUTH_KEY);
      removeItem(config.INFO);
      removeItem(config.NEW_TO_KNOCARD_KEY);
    });
    builder.addCase(logoutUser.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
    });

    builder.addCase(forgotPassword.pending, (state) => {
      state.isForgotPasswordLoading = true;
      state.forgotPasswordToken = undefined;
    });
    builder.addCase(forgotPassword.fulfilled, (state, action) => {
      state.isForgotPasswordLoading = false;
      if (action.payload?.data?.token) {
        state.forgotPasswordToken = action.payload?.data?.token || undefined
      }
    });
    builder.addCase(forgotPassword.rejected, (state, _) => {
      state.isForgotPasswordLoading = false;
      state.forgotPasswordToken = undefined;
    });
  },
});

export const { registrationSuccess, updateUserProfile, logoutUserFromLocal } = authSlice.actions;
export default authSlice.reducer;
